var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_21200",
    "data-name": "Group 21200",
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.62,
    height: 100.499,
    viewBox: "0 0 77.62 100.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21021",
    "data-name": "Path 21021",
    d: "M73.27,75.674V-11H6v86.67H27.992V51.84H51.278V75.674Z",
    transform: "translate(-0.825 18.357)",
    fill: "#cbe5ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21022",
    "data-name": "Path 21022",
    d: "M52.768-8.924H79.62v-7.762H2v7.762H28.851",
    transform: "translate(-2 16.686)",
    fill: "#a7c5f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21023",
    "data-name": "Path 21023",
    d: "M23,37.576H46.286v30.3H23Z",
    transform: "translate(4.167 32.621)",
    fill: "#7b8baf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21024",
    "data-name": "Path 21024",
    d: "M23,37.576v5.682H42.4V67.879h3.881v-30.3Z",
    transform: "translate(4.167 32.621)",
    fill: "#000064",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21183",
    "data-name": "Group 21183",
    transform: "translate(11.643 33.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21179",
    "data-name": "Group 21179"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21025",
    "data-name": "Path 21025",
    d: "M11,9h7.762v7.762H11Z",
    transform: "translate(-11 -9)",
    fill: "#a7c5f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21026",
    "data-name": "Path 21026",
    d: "M11,9v2.587h5.175v5.175h2.587V9Z",
    transform: "translate(-11 -9)",
    fill: "#000064",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21180",
    "data-name": "Group 21180",
    transform: "translate(15.524)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21027",
    "data-name": "Path 21027",
    d: "M23,9h7.762v7.762H23Z",
    transform: "translate(-23 -9)",
    fill: "#a7c5f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21028",
    "data-name": "Path 21028",
    d: "M23,9v2.587h5.175v5.175h2.587V9Z",
    transform: "translate(-23 -9)",
    fill: "#000064",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21181",
    "data-name": "Group 21181",
    transform: "translate(31.048)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21029",
    "data-name": "Path 21029",
    d: "M35,9h7.762v7.762H35Z",
    transform: "translate(-35 -9)",
    fill: "#a7c5f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21030",
    "data-name": "Path 21030",
    d: "M35,9v2.587h5.175v5.175h2.587V9Z",
    transform: "translate(-35 -9)",
    fill: "#000064",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21182",
    "data-name": "Group 21182",
    transform: "translate(46.572)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21031",
    "data-name": "Path 21031",
    d: "M47,9h7.762v7.762H47Z",
    transform: "translate(-47 -9)",
    fill: "#a7c5f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21032",
    "data-name": "Path 21032",
    d: "M47,9v2.587h5.175v5.175h2.587V9Z",
    transform: "translate(-47 -9)",
    fill: "#000064",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21188",
    "data-name": "Group 21188",
    transform: "translate(11.643 48.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21184",
    "data-name": "Group 21184"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21033",
    "data-name": "Path 21033",
    d: "M11,21h7.762v7.762H11Z",
    transform: "translate(-11 -21)",
    fill: "#a7c5f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21034",
    "data-name": "Path 21034",
    d: "M11,21v2.587h5.175v5.175h2.587V21Z",
    transform: "translate(-11 -21)",
    fill: "#000064",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21185",
    "data-name": "Group 21185",
    transform: "translate(15.524)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21035",
    "data-name": "Path 21035",
    d: "M23,21h7.762v7.762H23Z",
    transform: "translate(-23 -21)",
    fill: "#a7c5f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21036",
    "data-name": "Path 21036",
    d: "M23,21v2.587h5.175v5.175h2.587V21Z",
    transform: "translate(-23 -21)",
    fill: "#000064",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21186",
    "data-name": "Group 21186",
    transform: "translate(31.048)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21037",
    "data-name": "Path 21037",
    d: "M35,21h7.762v7.762H35Z",
    transform: "translate(-35 -21)",
    fill: "#a7c5f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21038",
    "data-name": "Path 21038",
    d: "M35,21v2.587h5.175v5.175h2.587V21Z",
    transform: "translate(-35 -21)",
    fill: "#000064",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21187",
    "data-name": "Group 21187",
    transform: "translate(46.572)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21039",
    "data-name": "Path 21039",
    d: "M47,21h7.762v7.762H47Z",
    transform: "translate(-47 -21)",
    fill: "#a7c5f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21040",
    "data-name": "Path 21040",
    d: "M47,21v2.587h5.175v5.175h2.587V21Z",
    transform: "translate(-47 -21)",
    fill: "#000064",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21191",
    "data-name": "Group 21191",
    transform: "translate(11.643 64.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21189",
    "data-name": "Group 21189"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21041",
    "data-name": "Path 21041",
    d: "M11,33h7.762v7.762H11Z",
    transform: "translate(-11 -33)",
    fill: "#a7c5f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21042",
    "data-name": "Path 21042",
    d: "M11,33v2.587h5.175v5.175h2.587V33Z",
    transform: "translate(-11 -33)",
    fill: "#000064",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21190",
    "data-name": "Group 21190",
    transform: "translate(46.572)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21043",
    "data-name": "Path 21043",
    d: "M47,33h7.762v7.762H47Z",
    transform: "translate(-47 -33)",
    fill: "#a7c5f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21044",
    "data-name": "Path 21044",
    d: "M47,33v2.587h5.175v5.175h2.587V33Z",
    transform: "translate(-47 -33)",
    fill: "#000064",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21194",
    "data-name": "Group 21194",
    transform: "translate(11.643 79.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21192",
    "data-name": "Group 21192"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21045",
    "data-name": "Path 21045",
    d: "M11,44.5h7.762v7.762H11Z",
    transform: "translate(-11 -44.5)",
    fill: "#a7c5f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21046",
    "data-name": "Path 21046",
    d: "M11,44.5v2.587h5.175v5.175h2.587V44.5Z",
    transform: "translate(-11 -44.5)",
    fill: "#000064",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21193",
    "data-name": "Group 21193",
    transform: "translate(46.572)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21047",
    "data-name": "Path 21047",
    d: "M47,44.5h7.762v7.762H47Z",
    transform: "translate(-47 -44.5)",
    fill: "#a7c5f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21048",
    "data-name": "Path 21048",
    d: "M47,44.5v2.587h5.175v5.175h2.587V44.5Z",
    transform: "translate(-47 -44.5)",
    fill: "#000064",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21199",
    "data-name": "Group 21199",
    transform: "translate(11.643 17.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21195",
    "data-name": "Group 21195"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21049",
    "data-name": "Path 21049",
    d: "M11-3h7.762V4.762H11Z",
    transform: "translate(-11 3)",
    fill: "#a7c5f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21050",
    "data-name": "Path 21050",
    d: "M11-3V-.413h5.175V4.762h2.587V-3Z",
    transform: "translate(-11 3)",
    fill: "#000064",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21196",
    "data-name": "Group 21196",
    transform: "translate(15.524)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21051",
    "data-name": "Path 21051",
    d: "M23-3h7.762V4.762H23Z",
    transform: "translate(-23 3)",
    fill: "#a7c5f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21052",
    "data-name": "Path 21052",
    d: "M23-3V-.413h5.175V4.762h2.587V-3Z",
    transform: "translate(-23 3)",
    fill: "#000064",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21197",
    "data-name": "Group 21197",
    transform: "translate(31.048)"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21053",
    "data-name": "Path 21053",
    d: "M35-3h7.762V4.762H35Z",
    transform: "translate(-35 3)",
    fill: "#a7c5f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21054",
    "data-name": "Path 21054",
    d: "M35-3V-.413h5.175V4.762h2.587V-3Z",
    transform: "translate(-35 3)",
    fill: "#000064",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21198",
    "data-name": "Group 21198",
    transform: "translate(46.572)"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21055",
    "data-name": "Path 21055",
    d: "M47-3h7.762V4.762H47Z",
    transform: "translate(-47 3)",
    fill: "#a7c5f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21056",
    "data-name": "Path 21056",
    d: "M47-3V-.413h5.175V4.762h2.587V-3Z",
    transform: "translate(-47 3)",
    fill: "#000064",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21057",
    "data-name": "Path 21057",
    d: "M2,56H29.167v6.468H2Zm50.453,0H79.62v6.468H52.453Z",
    transform: "translate(-2 38.031)",
    fill: "#a7c5f2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.2aa6d764712c687981f42211a34dd46f.svg";
export { ForwardRef as ReactComponent };